// A stable id for this install.
//
// Solo play creates a fresh users row per match, so nothing on the server has
// ever been able to answer "what has this player already been shown". The
// anti-repeat that existed was a 200-id list in localStorage, which a
// reinstall wiped and multiplayer never used at all.
//
// This is deliberately not an account. It identifies an install so the server
// can keep a serving memory; when real accounts land, auth_user_id takes
// precedence and this stays as the guest fallback.

const DEVICE_KEY = 'wot_device_id';

function makeId(): string {
  // crypto.randomUUID is not available on older Android WebViews, and this
  // value must never come back empty, so there is a manual fallback.
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  } catch { /* fall through */ }
  const hex = (n: number) => Math.floor(Math.random() * 16 ** n).toString(16).padStart(n, '0');
  return `${hex(8)}-${hex(4)}-4${hex(3)}-a${hex(3)}-${hex(12)}`;
}

/** The id for this install, minted once and kept. */
export function getDeviceId(): string {
  try {
    const existing = localStorage.getItem(DEVICE_KEY);
    if (existing && /^[0-9a-f-]{36}$/i.test(existing)) return existing;
    const fresh = makeId();
    localStorage.setItem(DEVICE_KEY, fresh);
    return fresh;
  } catch {
    // Private mode or a locked-down WebView: serving still works, it just
    // forgets between sessions, which is the behaviour we had before.
    return makeId();
  }
}
